import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DynamicContentEntranceService } from '@services/dynamic-content/dynamic-content-entrance.service';
import { OrganisationCustomerService } from '@services/customers/organisation-customer.service';
import { PageAction } from '../../components/page-actions/page-actions.component';
import { DialogService } from '@services/dialog/dialog.service';
import { OrganisationService } from '@services/organisations/organisation.service';
import { MessengerService } from '@services/messenger/messenger.service';
import { TranslateService } from '@services/translate/translate.service';
import { MatDialog } from '@angular/material/dialog';
import { PrivilegeGuard } from '../../guards/privilege.guard';

/* these Services are injected by dynamicContentEntranceService */
import { PackageService } from '@services/packages/package.service';
import { PackageInstalledAppsService } from '@services/packages/package-installed-apps.service';

import * as _ from 'lodash';

@Component({
    selector: 'app-dynamic-content-entrances',
    templateUrl: './dynamic-content-entrances.component.html',
    styleUrls: ['./dynamic-content-entrances.component.scss'],
    providers: [DynamicContentEntranceService, OrganisationCustomerService,
        PackageService, OrganisationService, PackageInstalledAppsService
    ],
    standalone: false
})
export class DynamicContentEntrancesComponent implements OnInit {

  public title: 'Dynamic content entrances';
  public pageActions: PageAction[];
  public entranceId;
  public customerId;
  public dynamicContentPackages = null;
  public columns = [
    { prop: 'title' }
  ];
  public isLoaded = false;
  public superAdmin = false;
  private systemMessages;

  constructor(
    public dynamicContentEntranceService: DynamicContentEntranceService,
    private packageService: PackageService,
    private organisationService: OrganisationService,
    private router: Router,
    private dialogService: DialogService,
    private dialog: MatDialog,
    private activatedRoute: ActivatedRoute,
    private messengerService: MessengerService,
    private ts: TranslateService,
    private priv: PrivilegeGuard
  ) {
    this.entranceId = this.activatedRoute.snapshot.queryParams['entranceId']; // routing from composition or organisationCustomer
    this.ts.get('system').then(translations => {
      this.systemMessages = translations;
    });
    this.superAdmin = this.priv.checkIfPrivilege('superadmin', 'packages');

    this.messengerService.$activeContents.subscribe(contents => {
      if (!this.messengerService.getOrganisation()) {
        return;
      }
      const query = { OwnerOrganisationID: this.messengerService.getOrganisation().OrganisationID }
      if (contents && contents.length) {
        const ids = _.map(contents, 'dynamicContentEntrance_Id');
        if (this.entranceId && ids.indexOf(this.entranceId) === -1) {
          this.isLoaded = true;
          return;
        }
        query['_id'] = this.entranceId ? this.entranceId : { $in: ids };
      } else if (this.entranceId) {
        query['_id'] = this.entranceId;
      }
      this.getPackagesByDynamicContentEntrances(query);
    });

  }

  ngOnInit() {
    this.isLoaded = false;
    if (!this.superAdmin) {
      this.columns[0]['valueTransformer'] = function(value) {
        if (value.indexOf('Touchscreen') > -1 || value.indexOf('Premium Touch') > -1) {
          return value;
        } else if (value.startsWith('*')) {
          return value.replace('*S:', 'ibextouch').replace('*W:', 'tweebie ').replace('*A:', 'tweebie ');
        } else {
          return 'tweebie ' + value;
        }
      };
    }
  }

  public onDetail(event) {
    this.router.navigate(['dynamic-content', event.row._id]);
  }

  private getPackagesByDynamicContentEntrances(query) {
    /*
     * get: only assigned entrances, and  packages and compositions
     * if no entrances or no assigned entrances: throws error
     */
    this.dynamicContentEntranceService.findAssigned(0, 100, query).then(result => {
      if (result && result.packages) {
        if (result.packages.length === 1) {
          this.router.navigate(['dynamic-content', result.packages[0]._id]);
          return;
        }
        if (!this.superAdmin && result.packages.length === 2 && (!result.packages[0].isScreenPackage || !result.packages[1].isScreenPackage)) {
          this.router.navigate(['dynamic-content', result.packages[0]._id + ',' + result.packages[1]._id]);
          return;
        }
      }
      this.dynamicContentPackages = result && result.packages ? result.packages : null;
      this.isLoaded = true;
    }).catch(err => {
      this.dynamicContentPackages = null;
      this.isLoaded = true;
    });
  }

}
